<script setup>

const props = defineProps({
    button_style: {
            type: String,
            default: 'text-white bg-lifeworx-blue-700 hover:bg-lifeworx-blue-600 focus:bg-lifeworx-blue-700 active:bg-lifeworx-blue-800 focus:ring-lifeworx-blue-500'
        },
    disabled: {
        type: Boolean,
        default: false
    }
})
</script>

<template>

    <button
        :class="`inline-flex items-center justify-center px-4 py-3 border border-transparent rounded-md uppercase font-semibold text-sm text-center tracking-wider focus:outline-none focus:ring-2 focus:ring-offset-2 transition ease-in-out duration-150 ${props.disabled ? 'bg-stone-300 text-stone-500 cursor-not-allowed' : button_style}`"
        :disabled="props.disabled"
    >
        <slot />
    </button>

</template>
